import React from "react";
import { Button, Form, Icon, Input, message, Row, Col, Typography } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import axios from 'axios';
import { isMobile } from 'react-device-detect';
import { API_PATH } from '../constants/ApiPath'
import OffersCarousel from "../components/OffersCarousel";
import "./signin.less"

import {
  hideMessage,
  userSignIn
} from "appRedux/actions/Auth";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;
const { Text, Title } = Typography;

class SignIn extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
      cloader: false,
      galleryData: null,
      carouselSpeed: 3000
    };
    this.getLoginType = this.getLoginType.bind(this);
    this.getLoginContent = this.getLoginContent.bind(this);
    if (this.state.token != null) {
      const role = localStorage.getItem('user_role') ? localStorage.getItem('user_role') : null;
      const rateId = localStorage.getItem("rateId") || null;
      const partnerPlans = localStorage.getItem("partnerPlans") || null;
      if ((role === 'project_manager' || role === 'coordinator' || role === 'admin' || role === 'partner') && partnerPlans) {
        this.props.history.push(`/partner-plans`);
      } else if ((role === 'project_manager' || role === 'coordinator' || role === 'admin' || role === 'partner') && rateId) {
        this.props.history.push(`/rate/${rateId}`);
      } else if (role === 'partner') {
        if(this.props.location?.state?.from?.pathname !== '/account-options'){
          this.props.history.push('/detail/'.concat(localStorage.getItem('user_uuid')));
        } else {
          this.props.history.push('/account-options');
        }
      }
      else if (role === 'agent' || role === 'internal_agent' || role === 'qa') {
        this.props.history.push('/records');
      }
      else if (role === 'accounts_user' || role === 'finance_user') {
        this.props.history.push('/finance');
      }
      else if (role === 'client_invoicer') {
        this.props.history.push('/client-invoices')
      }
      else if (role === 'project_manager') {
        this.props.history.push('/tasks')
      }
      else if (role === 'verify_scheduler') {
        this.props.history.push('/verify-schedule')
      }
      else if (role === 'coordinator') {
        this.props.history.push('/tasks')
      }
      else if (role === 'data_entry') {
        this.props.history.push('/tasks')
      }
      else if (role === 'client_user' || role === 'client_manager' || role === 'client_admin') {
        this.props.history.push('/client-project-list')
      }
      else if (role === 'qc') {
        this.props.history.push('/qc-ticket-list')
      }
      else if (role === 'auditor_user') {
        this.props.history.push('/audit-documents')
      }
      else if (role === 'customer_connect') {
        this.props.history.push('/raw-address')
      }
      else if (role === 'payable_partner_user') {
        this.props.history.push('/invoice-list')
      }
      else if (role === 'admin') {
        if (localStorage.getItem('loged_in_to') === "pmt")
          this.props.history.push('/tasks')
        else
          this.props.history.push('/records')
      }
      else if (role === 'kci') {
        this.props.history.push('/kci-tasks')
      }
      else if (role === 'partner_employee') {
        this.props.history.push('/account-options');
      }
      else if (role === 'logistics_user') {
        this.props.history.push('/logistics-product-tracking')
      }
      else {
        this.props.history.push('/not-authorized');
      }
    }
  }

  handleSubmit = (e) => {
    const { dispatch } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ cloader: true });
        const user = {
          email: values.email,
          password: values.password
        };
        const headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',

        }
        const endpoint = '/partner/login/'
        axios.post(API_PATH.concat(endpoint), user, { headers })
          .then(res => {
            if (res.data['status'] === 200) {
              localStorage.setItem('token', res.data['token']);
              localStorage.setItem('uuid', res.data['uuid']);
              localStorage.setItem('user_uuid', res.data.uuid)
              localStorage.setItem('ticket_role', res.data['ticket_role']);
              localStorage.setItem('all_roles', res.data['all_roles']);
              dispatch(userSignIn(res.data))
              if (res.data['all_roles'].length >= 1) {
                this.props.history.push('/interstitial', { from: { pathname: this.props?.location?.state?.from?.pathname } });
              } else {
                localStorage.setItem('user_role', res.data['user_role']);
                if (res.data['user_role'] === 'partner') {
                  localStorage.setItem('loged_in_to', "orion")
                  if(this.props.location?.state?.from?.pathname !== '/account-options'){
                    this.props.history.push('/detail/'.concat(res.data['uuid']));
                  } else {
                    this.props.history.push('/account-options');
                  }
                }
                else if (res.data['user_role'] === 'agent' || res.data['user_role'] === 'internal_agent' || res.data['user_role'] === 'qa') {
                  localStorage.setItem('loged_in_to', "orion")
                  this.props.history.push('/records');
                }
                else if (res.data['user_role'] === 'accounts_user' || res.data['user_role'] === 'finance_user') {
                  localStorage.setItem('loged_in_to', "fc")
                  this.props.history.push('/finance');
                }
                else if (res.data['user_role'] === 'client_invoicer' ) {
                  localStorage.setItem('loged_in_to', "fc")
                  this.props.history.push('/client-invoices');
                }
                else if (res.data['user_role'] === 'project_manager') {
                  localStorage.setItem('loged_in_to', "pmt")
                  this.props.history.push('/project');
                }
                else if (res.data['user_role'] === 'verify_scheduler') {
                  localStorage.setItem('loged_in_to', "pmt")
                  this.props.history.push('/verify-schedule');
                }
                else if (res.data['user_role'] === 'coordinator') {
                  localStorage.setItem('loged_in_to', "pmt")
                  if (isMobile) {
                    this.props.history.push('/tasks');  // Redirect to /tasks for mobile
                  } else {
                    this.props.history.push('/ticket-list');  // Keep the original route for desktop
                  }                
                }
                else if (res.data['user_role'] === 'data_entry') {
                  localStorage.setItem('loged_in_to', "pmt")
                  this.props.history.push('/tasks');
                }
                else if (res.data['user_role'] === 'client_user' || res.data['user_role'] === 'client_manager' || res.data['user_role'] === 'client_admin') {
                  localStorage.setItem('loged_in_to', "pmt")
                  this.props.history.push('/client-project-list');
                }
                else if (res.data['user_role'] === 'qc') {
                  localStorage.setItem('loged_in_to', "pmt")
                  this.props.history.push('/qc-ticket-list');
                }
                else if (res.data['user_role'] === 'auditor_user') {
                  localStorage.setItem('loged_in_to', "pmt")
                  this.props.history.push('/audit-documents');
                }
                else if (res.data['user_role'] === 'customer_connect') {
                  localStorage.setItem('loged_in_to', "pmt")
                  this.props.history.push('/raw-address');
                }
                else if (res.data['user_role'] === 'payable_partner_user') {
                  localStorage.setItem('loged_in_to', "ppl")
                  this.props.history.push('/invoice-list');
                }
                else if (res.data['user_role'] === 'kci') {
                  localStorage.setItem('loged_in_to', "kci")
                  this.props.history.push('/kci-tasks')
                }
                else if (res.data['user_role'] === 'partner_employee') {
                  localStorage.setItem('loged_in_to', "orion")
                  this.props.history.push('/account-options');
                }
                else if (res.data['user_role'] === 'logistics_user') {
                  localStorage.setItem('loged_in_to', "pmt")
                  this.props.history.push('/logistics-product-tracking');
                }
                else {
                  this.props.history.push('/interstitial', { from: { pathname: this.props?.location?.state?.from?.pathname } });
                }
              }
            } else {
              this.setState({ cloader: false });
              message.error(res.data['message'])
            }
          })
          .catch(error => {
            this.setState({ cloader: false });
            if (error.response.status === 401) {
              message.error(error.response.data['message'])
            } else {
              console.log(error);
              message.error(error.toString())
            }
          });

      }
    });
  };

  getLoginType = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const type = urlParams.get('type');
    // Also check localStorage as fallback
    return type || localStorage.getItem('loged_in_to') || 'default';
  }

  getLoginContent = () => {
    const loginType = this.getLoginType();
    const contentMap = {
      'pmt': {
        title: 'Project Management Sign In',
        description: 'Login to manage your projects and tasks. Matrix is the one stop interface for project management and coordination.'
      },
      'orion': {
        title: 'Partner Management Sign In',
        description: 'Login to manage your partner account and access partner services. Matrix connects you with Uniserved.'
      },
      'fc': {
        title: 'Finance Central Sign In',
        description: 'Login to access finance and accounting features. Matrix provides comprehensive financial management tools.'
      },
      'customer': {
        title: 'Client Portal Sign In',
        description: 'Login to access your client portal and manage your projects. Matrix is your gateway to Uniserved services.'
      },
      'default': {
        title: 'Sign In',
        description: 'Login to manage your projects and showcase your skills. Matrix is the one stop interface between you and Uniserved.'
      }
    };
    return contentMap[loginType] || contentMap['default'];
  }

  getLeftSideContent = () => {
    const loginType = this.getLoginType();
    const contentMap = {
      'pmt': {
        title: 'Matrix',
        subtitle: 'Field Services Management',
        quote: '"Efficient project coordination and task management. Matrix helps you deliver projects on time, every time."',
        author: 'Project Management Team',
        bgColor: 'rgba(99, 0, 134, 0.7)',
        gradientColor: '#630086'
      },
      'orion': {
        title: 'Partner Management',
        subtitle: 'Empower Your Partnership',
        quote: '"Seamless partner collaboration and account management. Matrix connects partners with Uniserved services."',
        author: 'Partner Services Team',
        bgColor: 'rgba(99, 0, 134, 0.7)',
        gradientColor: '#630086'
      },
      'fc': {
        title: 'Finance Central',
        subtitle: 'Financial Excellence',
        quote: '"Comprehensive financial management and accounting tools. Matrix provides complete financial control."',
        author: 'Finance Team',
        bgColor: 'rgba(99, 0, 134, 0.7)',
        gradientColor: '#630086'
      },
      'customer': {
        title: 'Client Portal',
        subtitle: 'Your Gateway to Services',
        quote: '"Access your projects and services seamlessly. Matrix is your direct connection to Uniserved."',
        author: 'Client Success Team',
        bgColor: 'rgba(99, 0, 134, 0.7)',
        gradientColor: '#630086'
      },
      'default': {
        title: 'Matrix',
        subtitle: 'Field Services Management',
        quote: '"The most comprehensive field services platform. Streamline your operations with Matrix."',
        author: 'Uniserved Team',
        bgColor: 'rgba(99, 0, 134, 0.7)',
        gradientColor: '#630086'
      }
    };
    return contentMap[loginType] || contentMap['default'];
  }

  componentDidMount() {
    const loginType = this.getLoginType();
    // Fetch gallery for customer or partner login types
    if (loginType === 'customer' || loginType === 'orion' || loginType === 'partner') {
      this.loadGallery();
    }
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.state.token != null) {
      this.props.history.push('/dashboard');
    }
  }

  loadGallery = () => {
    const cacheKey = 'gallery_cache_customer';
    const cachedData = localStorage.getItem(cacheKey);
    
    if (cachedData) {
      try {
        const parsed = JSON.parse(cachedData);
        // Use cached data immediately
        if (parsed.images && parsed.images.length > 0) {
          this.setState({
            galleryData: parsed.images,
            carouselSpeed: parsed.speed || 3000
          });
        }
        // Check for updates in background by comparing updated_at
        this.checkGalleryUpdate(parsed.updated_at);
        return;
      } catch (e) {
        console.error('Error parsing cached gallery data:', e);
      }
    }
    
    // No cache, fetch fresh data
    this.fetchGallery();
  }

  checkGalleryUpdate = (cachedUpdateDate) => {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
    const endpoint = '/management/get-gallery/?portal_type=partner';
    
    axios.get(API_PATH.concat(endpoint), { headers })
      .then(res => {
        if (res.data && res.data.length > 0) {
          const apiUpdateDate = res.data[0].updated_at;
          const cachedDate = new Date(cachedUpdateDate);
          const apiDate = new Date(apiUpdateDate);
          
          // Only update if API data is newer
          if (apiDate > cachedDate) {
            this.saveGalleryToCache(res.data[0]);
            if (res.data[0].images && res.data[0].images.length > 0) {
              const sortedImages = res.data[0].images.sort((a, b) => a.order - b.order);
              this.setState({
                galleryData: sortedImages,
                carouselSpeed: res.data[0].speed || 3000
              });
            }
          }
        }
      })
      .catch(error => {
        console.error('Failed to check gallery update:', error);
      });
  }

  fetchGallery = () => {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
    const endpoint = '/management/get-gallery/?portal_type=partner';
    
    axios.get(API_PATH.concat(endpoint), { headers })
      .then(res => {
        if (res.data && res.data.length > 0 && res.data[0].images && res.data[0].images.length > 0) {
          const sortedImages = res.data[0].images.sort((a, b) => a.order - b.order);
          this.saveGalleryToCache(res.data[0]);
          this.setState({
            galleryData: sortedImages,
            carouselSpeed: res.data[0].speed || 3000
          });
        } else {
          console.log('No images found in gallery response');
        }
      })
      .catch(error => {
        console.error('Failed to fetch gallery:', error);
      });
  }

  saveGalleryToCache = (galleryData) => {
    const cacheKey = 'gallery_cache_customer';
    const cacheData = {
      images: galleryData.images.sort((a, b) => a.order - b.order),
      speed: galleryData.speed || 3000,
      updated_at: galleryData.updated_at
    };
    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { showMessage, alertMessage } = this.props;
    const loginType = this.getLoginType();
    const leftSideContent = this.getLeftSideContent();
    const portalLabelMap = {
      pmt: 'Project Management',
      orion: 'Partner Management',
      partner: 'Partner Management',
      fc: 'Finance Central',
      customer: 'Client Portal',
      default: 'Project Management'
    };
    const portalLabel = portalLabelMap[loginType] || portalLabelMap.default;
    const leftFallbackImage = loginType === 'fc'
      ? require('assets/images/finance_Technicians_at_Work.png')
      : loginType === 'orion'
      ? require('assets/images/partner_Technicians_at_Work.png')
      : require('assets/images/Service_Technicians_at_Work.png');
    return (
      <div className="gx-app-login-wrap modern-signin-wrapper">
        <div className="gx-app-login-container modern-signin-container">
          <Row type="flex" align="middle" className="gx-app-login-main-content modern-signin-main" gutter={0}>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-left">
              <div 
                className="modern-signin-left-bg"
                style={{backgroundColor: '#FAFAFA'}}
              >
                <div className="modern-signin-left-content">
                  {loginType === 'customer' && this.state.galleryData && this.state.galleryData.length > 0 ? (
                    <OffersCarousel
                      images={this.state.galleryData}
                      speed={this.state.carouselSpeed || 5000}
                      fallbackSrc={leftFallbackImage}
                    />
                  ) : (
                    <img src={leftFallbackImage} alt='Graphic' className="modern-signin-graphic" />
                  )}
                </div>
              </div>
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-right"  >
              <div className="modern-signin-form-container">
                <div className="modern-signin-header">
                  <div className="modern-signin-header-left">
                    <Title level={2} className="modern-signin-header-title">Matrix</Title>
                    <Text className="modern-signin-header-subtitle">Field Services Management</Text>
                  </div>
                  <div className="modern-signin-header-right">
                    <img src={require('assets/images/Uniserved-Logo-square-for-light-bg.png')} alt='Logo' className="modern-signin-header-logo" />
                  </div>
                </div>
                <div className="modern-signin-form-content">
                <Text className="modern-signin-portal-label">{portalLabel}</Text>
                  <Title level={1} className="modern-signin-form-title" style={{color: '#262626'}}>Sign In</Title>
                  <Text className="modern-signin-form-text">{this.getLoginContent().description}</Text>
                  <Form layout="vertical" onSubmit={this.handleSubmit} className="modern-signin-form">
                    <FormItem
                      label="* Your email address:"
                      className="modern-signin-form-item"
                      required={false}
                    >
                      {getFieldDecorator('email', {
                        initialValue: "",
                        rules: [{
                          required: true, type: 'email', message: 'The input is not valid E-mail!',
                        }],
                      })(
                        <Input placeholder="Enter your email here..." className="modern-signin-input" />
                      )}
                    </FormItem>
                    <FormItem
                      label="* Your password:"
                      className="modern-signin-form-item"
                      required={false}
                    >
                      {getFieldDecorator('password', {
                        initialValue: "",
                        rules: [{ required: true, message: 'Please input your Password!' }],
                      })(
                        <Input type="password" placeholder="Enter your password here..." className="modern-signin-input" />
                      )}
                    </FormItem>
                    <div className="modern-signin-forgot">
                      <Link to="/forgot-password" className="modern-signin-forgot-link">Forgot password?</Link>
                    </div>
                    <FormItem className="modern-signin-submit-item">
                      <div className="modern-signin-submit-wrapper">
                        <Button type="primary" className="modern-signin-submit-btn" htmlType="submit">
                          <Icon type="lock" /> Sign in
                        </Button>
                        <div className="modern-signin-account-link-wrapper">
                          <span className="modern-signin-account-text">Don't have an account?</span>
                          <Link to="/signup" className="modern-signin-account-link">Sign up</Link>
                        </div>
                      </div>
                    </FormItem>
                  </Form>
                </div>
              </div>
              {this.state.cloader ?
                <div className="gx-loader-view">
                  <CircularProgress />
                </div> : null}
              {showMessage ?
                message.error(alertMessage.toString()) : null}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser, logedInUser } = auth;
  return { loader, alertMessage, showMessage, authUser, logedInUser }
};

export default connect(mapStateToProps,)(WrappedNormalLoginForm);
